import React, { Fragment } from "react";

import { BulkDeleteWithConfirmButton } from "react-admin";

import CloneAllButton from "./buttons/CloneAllButton";

const BulkActionButtons = (props) => (
	<Fragment>
		<CloneAllButton {...props} />
		<BulkDeleteWithConfirmButton {...props} />
	</Fragment>
);
export default BulkActionButtons;
